// api出口文件，各个模块的出口文件
import * as test from './modules/test'

import * as portal from './portal'

// 导出接口
export default {
  ...test,
  ...portal
}
